import {
  BMSPathname,
  useShouldOpenPackageInNewTab
} from './useShouldOpenPackageInNewTab'

/**
 * Custom hook for ECP-9501 experiment to determine if links should open in a new tab.
 *
 * This hook is designed to be used in menu items where it's necessary to check the pathname
 * to determine if the link should open in a new tab. The implementation is simple - it's a
 * wrapper around the original hook that maintains all the business logic.
 *
 * @param urlPathname - The URL pathname to check against BMS pathname
 * @returns boolean indicating whether the link should open in a new tab
 */
export const useShouldOpenLinkInNewTab = (urlPathname: string): boolean => {
  // Check if current prop exists and matches BMSPathname (if provided and valid)
  const isBMSPathname = urlPathname === BMSPathname
  const shouldOpenPackageInNewTab = useShouldOpenPackageInNewTab()

  return isBMSPathname && shouldOpenPackageInNewTab
}
